import '../application/content_structure/base.js';
import '../application/content_structure/breadcrumbs.js';
import '../application/content_structure/search.js';
import '../application/content_structure/topic.js';
import '../application/content_structure/tracking.coffee';
import '../application/content_structure/use_case_selector.js';
import '../application/content_structure/secondary_exercises.js';
import '../application/content_structure/sofaheld_level_selection.js';
import '../application/content_structure/chatbot_feedback_form_popup.js';
import '../application/content_structure/schoolbook_mapping_popup.js';
import '../application/content_structure/schoolbook_selection_popup.js';
import '../application/content_structure/sofabuddy_card.js';

import '../application/welcome/deeplinks.js';

import '../application/content_structure/content_structure.sass';
import '../application/layouts/_neon_blink_animation.sass';
